<template>
    <button class="btn btn-default" :disabled="isSubmitted" @click="remove()">
        <i class="fa fa-spin fa-spinner" v-if="isSubmitted"></i>
        <i class="fa fa-times text-danger" v-else></i>
    </button>
</template>
<script>
    export default {

        props: {
            method: {
                type: Object,
                required: true
            },
            default: {
                type: Object,
                required: true
            },
            user: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                isSubmitted: false,
            }
        },

        methods: {
            remove() {
                Alert.confirmation('Do you really want to delete this card?').then(() => {
                    this.isSubmitted = true;
                    axios.delete(`/billing/${this.user.slug}/payment-methods/${this.method.id}`).then(response => {
                        this.isSubmitted = false;
                        this.refreshPage();
                    })
                }).catch(error => {
                })
            }
        },

        computed: {
            isDefaultCard() {
                return this.card.id == this.default.id;
            }
        }
    }
</script>
